import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Page } from "@digital-services/shell";

import {
  BreadCrumbItem,
  CustomBreadCrumb
} from "@components/BreadCrumb/CustomBreadCrumb";

import { ApplicationsPanel } from "@application/components/ApplicationsPanel";

const ApplicationsPage: FunctionComponent = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "applications" });
  const { t: tCommon } = useTranslation();

  const breadCrumbs: BreadCrumbItem[] = [
    {
      name: tCommon("home.nav_item.label"),
      url: "/"
    },
    {
      name: tCommon("applications.nav_item.label")
    }
  ];

  return (
    <Page title={t("page_title")}>
      <CustomBreadCrumb breadCrumbs={breadCrumbs} />
      <div
        className="mt-3 flex flex-col"
        data-testid="application-panel-container"
      >
        <ApplicationsPanel />
      </div>
    </Page>
  );
};

export default ApplicationsPage;
